export const pathname = (state) => state.router.location.pathname;
